import { CarrierSelect } from 'browser/components/atomic-elements/atoms/select/carrier-select/carrier-select'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const CarrierSelectField = LabelFieldFactory({ InputComponent: CarrierSelect })
export { CarrierSelectField }
